import { render, staticRenderFns } from "./AsDetail.vue?vue&type=template&id=6ce76e22"
import script from "./AsDetail.vue?vue&type=script&lang=js"
export * from "./AsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports